<template>
  <div>
    <v-row class="pb-7">
      <v-col cols="12">
        <p class="gray--text font-weight-bold quotation-title">
          TIPO DE EMISSÃO
        </p>
      </v-col>
      <v-col cols="12" class="mb-5" v-if="isAdditionalCoverageRequired">
        <v-switch
          v-model="form.cobertura_adicional"
          class="pa-0 ma-0 justify-self-center d-inline-block base-form-switch"
          inset
          dense
          hide-details
          color="secondary"
        />
        <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
          Há cobertura adicional
          <v-tooltip bottom content-class="tooltip-label-form">
            <template v-slot:activator="{ on }">
              <v-icon color="secondary" size="10" v-on="on">
                fa-info-circle
              </v-icon>
            </template>
            <v-row>
              <v-col cols="12" class="px-4 py-3">
                <p class="white--text tooltip-label-text mb-0">
                  Selecione esta opção caso o contrato objeto do seguro possua
                  coberturas adicionais a serem inseridas no seguro. Por
                  exemplo, cobertura de multas contratuais ou de obrigações
                  trabalhistas e previdenciárias. Descreva abaixo as condições
                  exigidas.
                </p>
              </v-col>
            </v-row>
          </v-tooltip>
        </p>
      </v-col>
      <v-col cols="12" v-if="isContractInfoRequired">
        <BaseFormTextArea
          id-element="infoContractProcessQuotation"
          placeholder="Informe"
          v-model="form.informacoes_contrato"
          required
          :rules="[requiredInput, maxLengthTextArea]"
          label-text="Informações do contrato"
          icon-information
          text-information="Aqui você deve descrever todas as características relevantes do contrato que é objeto do seguro garantia para qual solicita cotação. Informações como valores e prazos são essenciais."
        />
      </v-col>
      <fragment v-if="isTypeProcessRequired">
        <v-col
          v-for="(item, key) of listEmissionType"
          :key="key"
          cols="12"
          sm="5"
          md="3"
          class="pr-5 pb-5 pb-md-0 d-flex justify-center justify-sm-start"
        >
          <QuotationCard
            @click="selectedItem(item)"
            :name="item.title"
            :class="{ 'base-card-active': item === tipo_processo }"
            :name-icon="item.image"
            :icon-default="false"
          />
        </v-col>
      </fragment>
    </v-row>
    <v-row v-if="hasProcess" class="pb-12">
      <v-col
        cols="12"
        sm="6"
        class="pr-sm-5"
        v-if="isEletronicProcess"
      >
        <BaseFormInput
          id-element="numberProcessQuotation"
          placeholder="Digite"
          v-model="form.numero_processo"
          required
          validate-on-blur
          v-facade="maskNumberProcess"
          :rules="[requiredInput, numberProcessValid]"
          label-text="Número do Processo"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6" class="pr-sm-5" v-else>
        <BaseFormInput
          id-element="numberProcessQuotation"
          placeholder="Digite"
          v-model="form.numero_processo"
          required
          validate-on-blur
          :rules="[requiredInput, maxLengthPhysicalProcess]"
          label-text="Número do Processo"
        />
      </v-col>
      <v-col cols="12" sm="6" class="pr-sm-5">
      </v-col>
      <v-col
        cols="12"
        sm="6"
        class="pr-md-5"
        v-if="hasSelectableCourt"
      >
        <BaseFormSelect
          id-element="justiceRegionQuotation"
          placeholder="Seleção"
          v-model="form.tribunal"
          :items="listJusticeRegion"
          item-text="nome"
          item-value="id"
          :return-object="true"
          required
          :rules="[requiredInput]"
          :label-text="nameLabelCourt"
        />
      </v-col>
      <v-col cols="12" sm="6" class="pr-md-5" v-else>
        <BaseFormInput
          id-element="justiceRegionQuotation"
          placeholder="Digite"
          v-model="form.nome_tribunal"
          required
          :rules="[requiredInput]"
          :label-text="nameLabelCourt"
          validate-on-blur
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        class="pr-sm-5 pr-lg-0"
        v-if="hasSelectableCourt"
      >
        <BaseFormSelect
          id-element="courtJusticeQuotation"
          placeholder="Seleção"
          v-model="form.unidade"
          :items="listCourtJustice"
          item-text="nome"
          item-value="id"
          :return-object="true"
          required
          :rules="[requiredInput]"
          :label-text="nameLabelJusticeRegion"
        />
      </v-col>
      <v-col cols="12" sm="6" class="pr-sm-5 pr-lg-0" v-else>
        <BaseFormInput
          id-element="courtJusticeQuotation"
          placeholder="Digite"
          v-model="form.nome_unidade"
          required
          :rules="[requiredInput]"
          :label-text="nameLabelJusticeRegion"
          validate-on-blur
        />
      </v-col>
      <v-col cols="12" class="mt-5">
        <v-divider />
      </v-col>
    </v-row>
    <v-row class="pb-5">
      <v-col cols="12">
        <p class="form__title primary--text">
          Anexar arquivos auxiliares
        </p>
        <p class="form__label primary--text mb-2">
          São recomendados anexar os seguintes arquivos:
        </p>
      </v-col>
      <v-col cols="12" sm="6" class="pb-5 pb-sm-0 pr-sm-5">
        <div class="deadline-emission-type__type-files pa-4">
          <p
            v-for="(item, key) in optionsQuotation.documentos_recomendados"
            :key="key"
            class="primary--text"
          >
            * {{ item }}
          </p>
        </div>
      </v-col>
      <v-col cols="12" sm="6">
        <DropFile
          @selected-files="addFilesQuotation"
          :multiple="false"
          class="mb-5"
        />
        <DocumentDataTable
          v-if="hasFiles"
          :documents="form.anexos"
          @preview-file="onPreviewFile"
          @remove-file="onRemoveFileQuotation"
        />
      </v-col>
      <v-col cols="12" class="deadline-emission-type__disclaimer pa-4 mt-5">
        <img src="@/assets/ic_warning.svg" class="px-1" />
        <label class="primary--text caption mb-0">
          A lista de documentos sugerida neste portal é exemplificativa, a
          seguradora pode solicitar documentos adicionais para melhor análise do
          risco.
        </label>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="5" lg="4" class="pr-sm-5">
        <BaseFormInput
          id-element="numberProposalQuotation"
          placeholder="Digite"
          v-model="form.numberProposal"
          label-text="Nº Interno Cliente"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="5"
        lg="4"
        class="pr-sm-5"
        v-if="isModalityJudicial"
      >
        <BaseFormSelect
          id-element="officeQuotation"
          placeholder="Seleção"
          v-model="form.escritorio"
          :items="listOfficeQuotation"
          item-text="nome_fantasia"
          item-value="id"
          label-text="Escritório Responsável"
          :return-object="true"
          required
          :rules="[requiredInput]"
          :disabled="disabledOffice"
          validate-on-blur
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
const mockEmissionType = [
  {
    title: "Processo Físico",
    id: "fisico",
    image: require("@/assets/processo_fisico.png")
  },
  {
    title: "Processo Eletrônico",
    id: "eletronico",
    image: require("@/assets/processo_digital.png")
  }
];
import {
  requiredInput,
  numberProcessValid,
  maxLengthPhysicalProcess,
  maxLengthTextArea
} from "@/utils/rules.js";
import CardDescriptionButton from "@/components/CardDescriptionButton.vue";
import { maskNumberProcess } from "@/utils/masks.js";
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import OfficeMixin from "@/mixins/OfficeMixin";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import DropFile from "@/components/DropFile.vue";
import DocumentDataTable from "@/components/DocumentDataTable";
import LabelInputMixin from "@/mixins/LabelInputMixin";
export default {
  data: () => ({
    listEmissionType: mockEmissionType,
    requiredInput,
    tipo_processo: {
      id: null,
      title: null
    },
    physicalProcess: {
      title: "Processo Físico",
      id: "fisico"
    },
    electronicProcess: {
      title: "Processo Eletrônico",
      id: "eletronico"
    },
    // ID fixado por hora, quando tiver outras
    // modalidades e submodalidades
    // ele virá do back-end
    segmentID: "justica_trabalho",
    list: [1, 2, 3],
    maskNumberProcess,
    numberProcessValid,
    maxLengthPhysicalProcess,
    maxLengthTextArea
  }),
  mixins: [LoadingRequest, OfficeMixin, DocumentsMixin, LabelInputMixin],
  components: {
    QuotationCard: CardDescriptionButton,
    DropFile,
    DocumentDataTable
  },
  mounted() {
    if (this.isSubmodalityAdministrative) {
      // Para submodalidade administrativa, os campos de nome_unidade e nome_tribunal
      // devem vir definidos como padrão por N/A, pois nem sempre existem estes campos
      // pois como o campo é obrigatório e eles não querem tirar ela apenas para
      // esta submodalidade, então cria estes valores default no caso de não ter valor.
      this.form.nome_unidade = !this.form.nome_unidade
        ? "N/A"
        : this.form.nome_unidade;
      this.form.nome_tribunal = !this.form.nome_tribunal
        ? "N/A"
        : this.form.nome_tribunal;
    }
  },
  computed: {
    ...mapState("quotation", [
      "listCourtJustice",
      "listJusticeRegion",
      "eletronicProcessValue",
      "listOfficeQuotation"
    ]),
    isTypeProcessRequired() {
      return this.optionsQuotation.processo_judiciario.tipo_processo
        .obrigatorio;
    },
    isAdditionalCoverageRequired() {
      return this.optionsQuotation.cobertura_adicional.obrigatorio;
    },
    isContractInfoRequired() {
      return this.optionsQuotation.informacoes_contrato.obrigatorio;
    },
    hasProcess() {
      return (
        (this.tipo_processo.id || !this.isTypeProcessRequired) &&
        this.isJudiciaryProcessNumberRequired
      );
    },
    isEletronicProcess() {
      return this.tipo_processo.id == "eletronico";
    },
    hasFiles() {
      return this.form.anexos && this.form.anexos.length > 0;
    },
    isJudiciaryProcessNumberRequired() {
      return this.optionsQuotation.processo_judiciario.numero_processo
        .obrigatorio;
    },
    hasSelectableCourt() {
      return !this.optionsQuotation.processo_judiciario.tribunal.nome_livre;
    },
    isModalityJudicial() {
      return this.readonlyForm.modality.id === "judicial";
    },
    isSubmodalityAdministrative() {
      return this.readonlyForm.subModality.id === "administrativa";
    }
  },
  methods: {
    ...mapActions("quotation", [
      "requestJusticeRegion",
      "requestNumberProcess",
      "requestCourtJustice"
    ]),
    ...mapActions(["hasLoading", "showAlertNotification"]),
    selectedItem(item) {
      this.tipo_processo = item;
      this.form.tipo_processo = item;
    },
    fetchJusticeRegion() {
      this.withLoading(this.requestJusticeRegion(this.segmentID));
    },
    fetchNumberProcess() {
      this.withLoading(
        this.requestNumberProcess(this.getPayloadNumberProcess())
      );
    },
    fetchCourtJustice() {
      this.withLoading(this.requestCourtJustice(this.getPayloadCourtJustice()));
    },
    getPayloadNumberProcess() {
      return {
        id: this.segmentID,
        number: this.form.numero_processo
      };
    },
    getPayloadCourtJustice() {
      return {
        segmentID: this.segmentID,
        justiceID: this.form.tribunal.id
      };
    },
    addFilesQuotation(files) {
      this.form.anexos = this.addFiles(this.form.anexos, files);
    },
    onRemoveFileQuotation(file) {
      this.form.anexos = this.onRemoveFile(this.form.anexos, file);
    }
  },
  props: {
    form: {
      type: Object
    },
    optionsQuotation: {
      type: Object
    },
    readonlyForm: {
      type: Object
    }
  },
  watch: {
    tipo_processo(value) {
      if (value.id == this.physicalProcess.id) this.fetchJusticeRegion();
    },
    "form.numero_processo"(value) {
      value &&
        value.length == 25 &&
        this.tipo_processo.id == this.electronicProcess.id &&
        this.fetchNumberProcess();
    },
    "form.tribunal"(value) {
      if (value && this.hasSelectableCourt) this.fetchCourtJustice();
    },
    eletronicProcessValue(value) {
      if (this.tipo_processo.id == this.electronicProcess.id) {
        this.form.unidade = value.unidade;
        this.form.tribunal = value.tribunal;
      }
    }
  }
};
</script>
<style lang="sass">
.deadline-emission-type__
  &disclaimer
    border-radius: 4px
    background-color: #FFC55F
  &type-files
    border: 1px solid #D5D5E0 !important
    border-radius: 2px !important
    background-color: #FFFFFF !important
</style>
